import { Box, Button, Grid, styled, TextField } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '12%',
    left: '15%',
    width: '70%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: 'content-box'
}));

const ConditionNameText = styled(Grid)(() => ({
    display: 'flex',
    alignItems: 'center',
}));

const DataInputForm = styled(TextField)(() => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
}))

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '10rem',
    borderRadius: '100rem'
}));

const LoadButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    height: '1.8rem',
    width: '5rem',
    borderRadius: '100rem',
    margin: '0.55rem'
}));

const DeleteButton = styled(Button)(() => ({
    backgroundColor: '#E97132',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    height: '1.8rem',
    width: '5rem',
    borderRadius: '100rem',
    marginTop: '0.55rem',
    marginBottom: '0.55rem',
}));

export { modalStyle, ModalLabel, ConditionNameText, DataInputForm, CancelButton, LoadButton, DeleteButton }
